import { fetchFieldAgents, fetchLeadsData } from '@api/leads';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LeadsParams, LeadsState } from '@utils/types';

const TOTAL_VALUES_PER_PAGE = 100;

const initialState: LeadsState = {
  loading: false,
  error: false,
  results: [],
  fieldAgents: [],
  displayData: [],
  sortedData: [],
  dataPerPage: TOTAL_VALUES_PER_PAGE,
  page: 1,
  totalPages: 1,
  totalResults: 1,
};

export const getLeadsData = createAsyncThunk(
  'leads',
  async (params: LeadsParams | null, thunkAPI) => {
    try {
      const response = await fetchLeadsData(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
export const getFieldAgents = createAsyncThunk(
  'leads/fieldAgents',
  async (_, thunkAPI) => {
    try {
      const response = await fetchFieldAgents();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const leadsSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      const currentPage = action.payload;
      state.page = currentPage;

      const start = (currentPage - 1) * state.dataPerPage;
      const end = currentPage * state.dataPerPage;
      state.displayData = state.results.slice(start, end);
    },
    setSortedData: (state, action) => {
      state.displayData = action.payload;
    },
  },
  extraReducers: (builder) => {
    // 1
    builder.addCase(getLeadsData.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getLeadsData.fulfilled, (state, action) => {
      state.loading = false;
      const dataPayload = action.payload.lead_data;
      state.results = dataPayload;
      state.displayData = dataPayload?.slice(0, state.dataPerPage);
      state.totalResults = dataPayload?.length;
      state.totalPages = Math.ceil(dataPayload?.length / state.dataPerPage);
      state.error = false;
    });
    builder.addCase(getLeadsData.rejected, (state) => {
      state.loading = false;
      state.results = [];
      state.displayData = [];
      state.error = true;
    });

    //2
    builder.addCase(getFieldAgents.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getFieldAgents.fulfilled, (state, action) => {
      const dataPayload = action.payload;
      state.loading = false;
      state.fieldAgents = dataPayload.fls_names;
      state.page = 1;
      state.error = false;
    });
    builder.addCase(getFieldAgents.rejected, (state) => {
      state.loading = false;
      state.fieldAgents = [];
      state.error = true;
    });
  },
});

// Action creators are generated for each case reducer function
export const { setCurrentPage, setSortedData } = leadsSlice.actions;

export default leadsSlice.reducer;
